import { render, staticRenderFns } from "./SupplierReturnListView.vue?vue&type=template&id=b9580378&"
import script from "./SupplierReturnListView.vue?vue&type=script&lang=ts&"
export * from "./SupplierReturnListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9580378')) {
      api.createRecord('b9580378', component.options)
    } else {
      api.reload('b9580378', component.options)
    }
    module.hot.accept("./SupplierReturnListView.vue?vue&type=template&id=b9580378&", function () {
      api.rerender('b9580378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchasing/supplier-return/SupplierReturnListView.vue"
export default component.exports